/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: StageFeature.ts
 * Project: mle-client-n
 * Committed last: 2022/1/11 @ 115
 * ---
 * Description:
 */

import {Feature} from './Feature';
import Pamela from '@revodigital/pamela';
import {Editor} from '../../observables/Editor';

export abstract class StageFeature<T> extends Feature<Pamela.Stage, T, Editor> {
  protected constructor(name: string, parent: Editor, active: boolean) {
    super(name, parent.pamelaStage__nonObservable, parent, active);
  }
}